module.exports = __webpack_public_path__ + "img/nav_ico_1.6b824355.png";